const slugify = require("slugify")

// Helper to decode HTML entities (minimal, covers most common cases)
function decodeHTMLEntities(text) {
  return text
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#x2F;/g, "/")
    .replace(/&#x60;/g, "`")
    .replace(/&#x3D;/g, "=")
    .replace(/&nbsp;/g, " ")
}

const getIntro = item => {
  // Use mfn-preamble div content if present
  if (item.content && item.content.html) {
    // Try to extract the content of the first <div class="mfn-preamble">...</div>
    const preambleMatch = item.content.html.match(
      /<div[^>]*class=["'][^"']*mfn-preamble[^"']*["'][^>]*>([\s\S]*?)<\/div>/i
    )
    if (preambleMatch && preambleMatch[1]) {
      let text = preambleMatch[1].replace(/<[^>]+>/g, "").trim()
      return decodeHTMLEntities(text)
    }
  }
  // Fallback to first <p> if no mfn-preamble
  if (item.content && item.content.html) {
    const match = item.content.html.match(/<p[^>]*>(.*?)<\/p>/i)
    if (match && match[1]) {
      let text = match[1].replace(/<[^>]+>/g, "").trim()
      return decodeHTMLEntities(text)
    }
  }
  return ""
}

const getBody = item => {
  return (item.content && item.content.html ? item.content.html : "").replace(
    /<h1[^>]*>.*?<\/h1>/i,
    ""
  )
}

const getSlug = item => {
  return item.content && item.content.slug
    ? item.content.slug
    : slugify(
        (item.content && item.content.title ? item.content.title : item.title) +
          (item.content && item.content.publish_date
            ? item.content.publish_date
            : ""),
        { replacement: "_", remove: /[*+~.()'"!:@]/g }
      )
}

const isRegulatory = (item, title) => {
  const isRegulatoryForced = [
    "Checkin.com Group's IPO oversubscribed by over 2 000 percent, with a total subscription value of SEK 950 million",
    "Checkin.com Group conducts IPO of SEK 45 million on Nasdaq First North Growth Market",
  ].includes(title)

  const isRegulatory =
    item.properties && Array.isArray(item.properties.tags)
      ? item.properties.tags.some(tag =>
          tag.toLowerCase().includes("regulatory")
        )
      : isRegulatoryForced

  return isRegulatory
}

const formatPost = item => {
  const title =
    item.content && item.content.title ? item.content.title : item.title

  return {
    Title: title,
    PublishDate:
      item.content && item.content.publish_date
        ? item.content.publish_date
        : item.published,
    IsRegulatory: isRegulatory(item, title),
    Intro: getIntro(item),
    Slug: getSlug(item),
    HtmlBody: getBody(item),
    Url: item.url,
  }
}

module.exports = { getIntro, getBody, getSlug, isRegulatory, formatPost }
